import { cdnEndpoints } from './cdn-endpoints.function';

const cdnBaseUrl = 'https://content-dev.gruposancristobal.com/';

export const environment = {
  production: false,
  insured: {
    chat: {
      environmentId: '00D18000000CyiR',
      deploymentId: '572180000004CQx',
      buttonId: '573180000004Cg4',
      baseLiveAgentURL: 'https://d.la4-c1cs-phx.salesforceliveagent.com/chat',
    },
  },
  institutional: {
    chat: {
      environmentId: '00DU70000013MzV',
      deploymentId: '5721R000000LFsq',
      buttonId: '573Hq000000PcMb',
      baseLiveAgentURL:
        'https://d.la2s-core2.sfdc-lywfpd.salesforceliveagent.com/chat',
    },
  },
  whatsapp: '+5491134045795',
  cdn: cdnEndpoints(cdnBaseUrl),
};
